<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="initialSortBy"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/EventOrganizers/queries/eventOrganizersGrid.gql')
      }"
      :headers="$options.headersConfig"
      :filters="{
        id: { control: 'text', modifier: 'contains' },
        organizerName: { control: 'text', modifier: 'contains' },
        slug: { control: 'text', modifier: 'contains' },
        isFeatured: {
          control: 'select',
          options: [
            {
              value: true,
              text: 'Да'
            },
            {
              value: false,
              text: 'Нет'
            }
          ],
          dataType: Boolean
        },
        status: {
          control: 'select',
          options: [...$options.statusList],
          dataType: String
        },
        isArchived: {
          control: 'select',
          options: [
            {
              value: true,
              text: 'Да'
            },
            {
              value: false,
              text: 'Нет'
            }
          ],
          dataType: Boolean
        },
        createdAt: { control: 'date-range' },
        updatedAt: { control: 'date-range' },
        translations: {
          control: 'select',
          options: [
            {
              value: 'ru',
              text: 'ru'
            },
            {
              value: 'en',
              text: 'en'
            },
            {
              value: 'ja',
              text: 'ja'
            },
            {
              value: 'zh',
              text: 'zh'
            },
            {
              value: 'ko',
              text: 'ko'
            }
          ]
        }
      }"
      @query-state-updated="getStateQuery"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      :views-loading="$async.updateMe.$pending"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          fixed-header
          height="80vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
          v-model="mixSelectedItems"
          @update:sort-by="updateSortBy"
          @update:sort-desc="sortDesc = $event"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <!-- <span v-on="on">{{
                  $t(`events-categories.header-titles.${h.value}`)
                }}</span> -->
                <span v-on="on">
                  {{ h.text }}
                </span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value]) }}
              </div>
              <div v-else-if="h.text === 'Название'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-event-organizer',
                    params: { id: item.id }
                  }"
                  >{{ item[h.value] }}</router-link
                >
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.value === 'slug'">
                <div>{{ mixCutSlug(item[h.value]) }}</div>
              </div>
              <div v-else-if="h.value === 'copySlug'">
                <a title="Копировать">
                  <v-btn icon @click="mixCopySlugHandler(item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else-if="h.type === 'boolean'">
                <v-icon
                  v-text="'mdi-checkbox-marked-circle'"
                  :color="item[h.value] ? 'success' : 'grey'"
                />
              </div>
              <div
                v-else-if="h.type === 'actions'"
                :style="{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end'
                }"
              >
                <router-link
                  :to="{
                    name: 'page-event-organizer',
                    params: { id: item.id }
                  }"
                  title="Редактировать"
                  ><v-btn icon><v-icon>mdi-pencil</v-icon></v-btn></router-link
                >
                <a :title="getEventsCount(item) > 0 ? 'Удаление невозможно' : 'Удалить'">
                  <v-btn
                    icon
                    :disabled="getEventsCount(item) > 0 ? true : false"
                    @click="deleteEventOrganizer(item.id)"
                  >
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else-if="h.value === 'translations'">{{ getLanguage(item) }}</div>
              <div v-else-if="h.value === 'events'">{{ getEventsCount(item) }}</div>
              <div v-else-if="h.value === 'status'">{{ mixGetStatus(item) }}</div>
              <div v-else>
                {{ item[h.value] }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <ConfirmationDialog ref="confirmTouristAgencyRemoving" confirmText="Удалить" />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import { formatAmount } from '@/utils'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig.js'
import DataTableWrapper from '@/components/data-table-wrapper'
import DataTableFilters from '@/components/data-table-filters'
import DateTimeCell from '@/components/date-time-cell'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import deleteEventOrganizer from '@/services/gql/types/EventOrganizers/mutations/deleteEventOrganizer.gql'
import updateMeMutation from '@/services/gql/types/Me/mutations/updateMe.gql'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'

export default {
  name: 'GridPageEventOrganizers',
  gridType: 'touristAgencies',
  mixins: [gridDependentMixin],
  perPage,
  headersConfig,
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  components: {
    DataTableWrapper,
    DataTableFilters,
    DateTimeCell,
    ConfirmationDialog
  },
  data () {
    return {
      queryState: null,
      sortDesc: false,
      initialSortBy: []
    }
  },
  methods: {
    formatAmount,
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    async deleteEventOrganizer (id) {
      try {
        await this.$refs.confirmTouristAgencyRemoving.open()
        await this.$async.deleteEventOrganizer.$perform({
          id: Number(id)
        })
        this.$successMsg('Организатор мероприятий удален')
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e, `Ошибка при удалении организатора мероприятий с ID ${id}`)
      }
    },
    getEventsCount (item) {
      if (!item?.events) return 0
      return item.events?.length || 0
    },
    updateSortBy ([field]) {
      this.$set(this.initialSortBy, 0, {
        field,
        dir: this.sortDesc[0] ? 'desc' : 'asc'
      })
      this.refetch()
    }
  },
  async: {
    deleteEventOrganizer (variables) {
      return this.$apollo.mutate({
        mutation: deleteEventOrganizer,
        variables
      })
    },
    updateMe (variables) {
      return this.$apollo.mutate({
        mutation: updateMeMutation,
        variables
      })
    }
  }
}
</script>
